"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicCategoryBanners", {
  enumerable: true,
  get: function get() {
    return _usePrismicCategoryBanners["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicCategoryBanners = _interopRequireDefault(require("./usePrismicCategoryBanners"));
var _fetcher = _interopRequireDefault(require("./fetcher"));